import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export function TextAreaFormField({
  name,
}: {
  name: 'beschreibung' | 'specials';
}) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {name === 'beschreibung'
              ? t('domain.termine.description')
              : t('domain.termine.additionalInformation')}
          </FormLabel>
          <FormControl>
            <Textarea
              className={cn(
                'border border-neutrals-300 min-h-[84px] py-0',
                'ring-0 ring-offset-0 focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0',
                'outline-hidden focus:outline-hidden shadow-none',
              )}
              value={field.value}
              onChange={field.onChange}
              ref={field.ref}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
